<template>
  <modal ref='modal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('record_show.copy_to_folder', {name: record.filename}) }}</h5>
    </template>

    <template #body>
      <form @submit.prevent='copyFile($event)' class="modal-fix">
        <div class='modal-body'>
          <label>{{ $t('record_show.folder') }}</label>

          <div>
            <single-select :template='folderTemplate' :getter='getFolders' name='record[folder_id]' v-model='folder' />
          </div>
        </div>

        <div class='modal-footer'>
          <input type='submit' :value="$t('folder_show.modals.copy.submit')" class='btn btn-primary float-right' />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'
  import _single_select from '../_infinite_single_select'

  export default {
    components: {
      modal: _modal,
      'single-select': _single_select,
    },
    data() {
      return {
        record: {},
        folder: {},
      }
    },
    methods: {
      open(record) {
        this.record = Object.assign({}, record)
        this.$refs.modal.open()
      },
      copyFile(e) {
        this.store.copyRecord(this.record, new FormData(e.target)).then(() => {
          this.store.sendMetrics({name: 'copy_file', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.$refs.modal.close()
        })
      },
      getFolders(params) {
        return this.listStore.getFolders(params)
      },
    }
  }
</script>
